import Vue from 'vue';

const state = {
	categories: [],
	categories_loading: false
};

const getters = {
	categories: state => {
		return state.categories;
	}
};

const actions = {
	get({ commit, rootState }) {
		console.log('Retrieving Categories...');
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/categories`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	add({ commit, dispatch, rootState }, category) {
		console.log('Adding New Category...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/categories`, category)
				.then(resp => {
					commit('ADD_SUCCESS', category);
					dispatch('get');
					resolve(resp);
				})
				.catch(err => {
					console.log('Error saving Category');
					console.log(err);
					reject(err);
				});
		});
	},
	edit({ commit, dispatch, rootState }, category) {
		console.log('Updating Category...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/categories/${category.id}`, category)
				.then(resp => {
					commit('EDIT_SUCCESS', category);
					dispatch('get');
					resolve(category);
				})
				.catch(err => {
					console.log('Error updating Category');
					console.log(err);
					reject(err);
				});
		});
	},
	delete({ commit, dispatch, rootState }, category) {
		console.log('Deleting Category...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/categories/${category.id}`)
				.then(resp => {
					commit('DELETE_SUCCESS', category);
					dispatch('get');
					resolve(true);
				})
				.catch(err => {
					console.log('Error deleting Category');
					console.log(err);
					reject(err);
				});
		});
	}
};

const mutations = {
	GET_PENDING(state) {
		state.categories_loading = true;
	},
	GET_SUCCESS(state, data) {
		state.categories_loading = false;
		state.categories = data;
	},
	GET_FAILURE(state, error) {
		state.categories_loading = false;
		console.log(error);
	},
	ADD_SUCCESS(state, data) {
		state.categories.push(data);
	},
	EDIT_SUCCESS(state, data) {
		let found = state.categories.find(pr => pr.id === data.id);
		if (found != null) {
			found = data;
		}
	},
	DELETE_SUCCESS(state, data) {
		const index = state.categories.indexOf(data);
		state.categories.splice(index, 1);
	},
	ADD_MISSING_CATEGORIES(state, category) {
		const allCategories = state.categories.map(x => x.text.toLowerCase());
		if (category.toLowerCase() !== "n/a" && !allCategories.includes(category.toLowerCase())) {
			state.categories.push({
				id: `newCategory_${category}`,
				text: category
			})
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
